import script from "./TranslatableFields.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatableFields.vue?vue&type=script&setup=true&lang=js"

import "./TranslatableFields.vue?vue&type=style&index=0&id=01f31f00&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f31f00"]])

export default __exports__